import { FeaturePageVisual } from "@/features/feature-page/feature-page-visual";
import type { ResolvedFeaturePageEntity } from "@garimpa/api/featurePages/types";

export function FeaturePageEntityCard({
  entity,
  badge,
  note,
  priority = false,
}: {
  entity: ResolvedFeaturePageEntity;
  badge?: string;
  note?: string;
  priority?: boolean;
}) {
  return (
    <article className="group flex h-full min-w-0 flex-col">
      <a
        href={entity.href}
        className="block rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-4 focus-visible:ring-offset-background"
      >
        <div className="relative aspect-square overflow-hidden rounded-xl border border-border bg-[radial-gradient(circle_at_center,rgba(255,120,66,0.12),transparent_58%)] shadow-sm transition group-hover:border-primary/50 group-hover:shadow-md">
          {entity.image ? (
            <FeaturePageVisual
              visual={entity.image}
              priority={priority}
              className="h-full w-full object-cover transition duration-300 group-hover:scale-[1.03]"
            />
          ) : null}
          {badge ? (
            <span className="absolute left-2 top-2 rounded-full bg-background/90 px-2.5 py-1 text-xs font-bold backdrop-blur">
              {badge}
            </span>
          ) : null}
        </div>
        <h3 className="mt-3 truncate text-base font-bold transition-colors group-hover:text-primary">
          {entity.title}
        </h3>
        {!note && (entity.subtitle || entity.year) ? (
          <p className="truncate text-sm text-muted-foreground">
            {[entity.subtitle, entity.year].filter(Boolean).join(" · ")}
          </p>
        ) : null}
      </a>
      {note ? <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{note}</p> : null}
    </article>
  );
}
